<script>
  import { Col } from '@sveltestrap/sveltestrap';

  /** @type {boolean} */
  export let active = false;

  /** @type {string} */
  export let description = '';

  /** @type {string} */
  export let name = '';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<div
  class="list-group-item list-group-item-action row py-1 px-0 border-0 d-flex text-truncate"
  class:active
  role="listitem"
  on:dragstart
  on:click
  {...$$restProps}
>
  <Col xs={4} class="text-center">
    <div class="preview">
      <slot />
    </div>
  </Col>
  <Col xs={8}>
    <small class="d-block pt-2 text-truncate">
      {name}
    </small>
    <small class="description text-wrap">
      {description}
    </small>
  </Col>
</div>

<style lang="scss">
  img {
    max-width: 5rem;
  }

  .description {
    color: var(--color-gray-600);
  }

  .preview {
    background: conic-gradient(#ffffff 90deg, #eeeeee 90deg 180deg, #ffffff 180deg 270deg, #eeeeee 270deg);
    background-repeat: repeat;
    background-size: 20px 20px;
    background-position: top left;
    border: 1px solid var(--border-color);
    padding: var(--padding-xsmall);
  }
</style>
